import classNames from 'classnames';
import React from 'react';

import IconInfo from 'reactComponents/icons/info';

import styles from './InfoMessage.css';

type InfoMessageProps = {
    children: React.ReactNode;
    withoutIcon?: boolean;
    className?: string;
    label?: string;
};
export function InfoMessage({
    children,
    withoutIcon,
    className = '',
    label = '',
}: InfoMessageProps) {
    return (
        <div className={classNames(styles.root, className)}>
            {label && <div className={styles.label}>{label}</div>}
            <div className={styles.infoMessage}>
                {!withoutIcon && (
                    <div>
                        <IconInfo className={styles.icon} />
                    </div>
                )}
                <div className={styles.text}>{children}</div>
            </div>
        </div>
    );
}
